import { render, staticRenderFns } from "./FilmMobile.vue?vue&type=template&id=27ecace5&scoped=true&"
import script from "./FilmMobile.vue?vue&type=script&lang=js&"
export * from "./FilmMobile.vue?vue&type=script&lang=js&"
import style0 from "./FilmMobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FilmMobile.vue?vue&type=style&index=1&id=27ecace5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecace5",
  null
  
)

export default component.exports